import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Polyline, { points: "22 12 18 12 15 21 9 3 6 12 2 12", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Activity";
const Activity = memo(themed(Icon));
export {
  Activity
};
//# sourceMappingURL=activity.js.map
